
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M45.5 27.3c-1.1 0-2.2.2-3.3.6l-5.4-9.1c-.3-.5-.8-.8-1.4-.8h-4.5c-.6 0-1.1.5-1.1 1.2v1.2c0 .6.5 1.2 1.1 1.2h3.5l1 1.7h-7.9v-1.2c0-.6-.5-1.2-1.1-1.2h-6.1c-1 0-1.7.8-1.7 1.8s.8 1.7 1.7 1.7h3.4l-2.1 3.5c-1-.4-2-.5-3-.5-4.9 0-9 4.2-9 9.3 0 5.2 4 9.4 9 9.4 4.2 0 7.7-3 8.7-7h3.6c.6 0 1.1-.3 1.4-.8l6-10.1 1 1.8c-1.9 1.8-2.9 4.3-2.9 6.9 0 5 4.1 9.3 8.9 9.3 4.9.1 9-4.1 9-9.2.2-5.4-3.9-9.6-8.8-9.7zm-22.8 5.4c.7.8 1.2 1.7 1.4 2.8h-3l1.6-2.8zm-9.7 4c0 3.2 2.5 5.8 5.6 5.8 2.3 0 4.3-1.4 5.1-3.5H18c-1.3 0-2.1-1.5-1.4-2.7l3.2-5.4c-.4-.1-.8-.1-1.2-.1-3.1 0-5.6 2.7-5.6 5.9zm16.9-1.2h-2.5c-.3-2.2-1.3-4.3-3-5.8l1.7-2.9H35l-5.1 8.7zm9.9 1.4c.1 3 2.4 5.4 5.3 5.6 3.2.2 5.9-2.5 5.9-5.8 0-3.2-2.5-5.8-5.6-5.8-.5 0-.9.1-1.4.2l3.1 5.2c.3.5.2 1.3-.4 1.6l-1 .6c-.5.3-1.2.2-1.5-.3L41.1 33c-.8 1-1.3 2.4-1.3 3.9z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    